import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../../Logo';

interface BrandProps {
  sidebarExpanded: boolean;
  onToggleCollapse?: () => void;
}

const Brand: React.FC<BrandProps> = ({ sidebarExpanded, onToggleCollapse }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`obs-brand-container d-flex align-items-center px-3 py-3 w-100 ${sidebarExpanded ? 'gap-3' : 'justify-content-center position-relative'}`}
      style={{ minHeight: '64px' }}
    >
      <div
        role={!sidebarExpanded ? 'button' : undefined}
        onClick={() => !sidebarExpanded && onToggleCollapse && onToggleCollapse()}
        style={{ cursor: !sidebarExpanded ? 'pointer' : 'default' }}
        className="d-flex align-items-center justify-content-center"
      >
        <Logo sidebarExpanded={sidebarExpanded} />
      </div>
      {!sidebarExpanded && (
        <span className="obs-flyout">{t('layout.pageTexts.private.sidebar.expand') || 'Expand Navigation'}</span>
      )}
      {sidebarExpanded && onToggleCollapse && (
        <button
          type="button"
          aria-label={t('layout.pageTexts.private.sidebar.collapse') || 'Collapse'}
          onClick={onToggleCollapse}
          className="btn btn-sm btn-icon border p-0 d-flex align-items-center justify-content-center ms-auto"
          style={{
            width: '30px',
            height: '30px',
            borderRadius: '8px',
            borderColor: 'var(--line2)',
            color: 'var(--dim)',
            backgroundColor: 'transparent',
            transition: 'border-color 0.15s, color 0.15s',
          }}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="11 17 6 12 11 7" />
            <polyline points="18 17 13 12 18 7" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default Brand;

